import 'shepherd.js/dist/css/shepherd.css';
import confetti from '../../@vendor/confetti.js';
import { defineCommand } from '../../concepts/commands/CommandDefinition';
import { AppNavigator } from '../AppNavigator';
import { AccountModel } from '../account/AccountModel';
import { isItXmas } from '../occasions/xmas/WithXmas';
import { PreferencesModel } from '../preferences/PreferencesModel';
import { TourManager } from './TourManager';

export const tourStart = defineCommand(
    'tourStart',
    'Tour: Start',
    (r, [name]: [any]) => r.call(TourManager).start(name)
);

export const tourComplete = defineCommand(
    'tourComplete',
    'Tour: Complete',
    (r, [name]: [any]) => {
        const tm = r.call(TourManager);
        if (tm.current === name) {
            tm.complete();
        }
    }
);

export const tourCancel = defineCommand(
    'tourCancel',
    'Tour: Cancel',
    (r, [name]: [any]) => {
        const tm = r.call(TourManager);
        if (tm.current === name) {
            tm.cancel();
        }
    }
);

// This is kinda shit
export const gotoAnyWorkspaceForTour = defineCommand(
    'gotoAnyWorkspaceForTour',
    'gotoAnyWorkspaceForTour',
    r => {
        const wsl = r.call(AccountModel).workspaces;
        const hit = wsl.find(x => x.type === 'user') ?? wsl[0];
        if (hit) {
            r.call(AppNavigator).go(`~/${hit.id}?tour=1`);
        }
    }
);

export const confettiScreen = defineCommand(
    'confettiScreen',
    'Confetti: Screen',
    (r, [x, y, angle, duration]: [number, number, number, number?]) => {
        const end = Date.now() + (duration || 500);
        let offset = 0;
        const colors = isItXmas() && !r.call(PreferencesModel).scrooge2024
            ? ['#29a583', '#c9040b', '#28560b', '#fc1934', '#c09209',]
            : undefined;
        (function frame() {
            confetti({
                colors,
                particleCount: 1,
                particleOffset: (offset += 2),
                angle,
                spread: 55,
                origin: { x, y },
                zIndex: 50,
            });
            confetti({
                colors,
                particleCount: 1,
                particleOffset: offset,
                angle,
                spread: 55,
                origin: { x, y },
                zIndex: 50,
            });
            if (Date.now() < end) {
                requestAnimationFrame(frame);
            }
        }());
    }
);
